/**
 * BS PDP Sticky Add-to-Cart Bar — wszystkie viewporty (mobile priorytet).
 * Pokazuje pasek z miniatura + nazwa + cena + CTA, gdy buy-box wyjedzie z widoku.
 * Idempotentny: bezpieczny przy ponownym renderze sekcji w edytorze (shopify:section:load).
 */
(function () {
  function buildBar() {
    if (document.querySelector('.bs-pdp-sticky-bar')) return;

    var productInfo = document.querySelector('product-info, .product__info-container');
    var buyButtons = document.querySelector('.product-form__buttons');
    if (!productInfo || !buyButtons) return;

    var titleEl = document.querySelector('.product__title h1, .product__title');
    var priceEl = document.querySelector('.price__sale .price-item--sale, .price-item--regular, .price__regular .price-item');
    var img = document.querySelector('.product__media img, .product-media img, .product__column img');

    var title = titleEl ? titleEl.textContent.trim() : (document.title || '');
    var price = priceEl ? priceEl.textContent.trim() : '';

    var bar = document.createElement('div');
    bar.className = 'bs-pdp-sticky-bar';
    var mediaHTML = img && img.currentSrc
      ? '<img class="bs-pdp-sticky-bar__media" src="' + img.currentSrc + '" alt="" loading="lazy">'
      : '<span class="bs-pdp-sticky-bar__media"></span>';
    bar.innerHTML =
      '<div class="bs-pdp-sticky-bar__inner">' +
        mediaHTML +
        '<span class="bs-pdp-sticky-bar__info">' +
          '<span class="bs-pdp-sticky-bar__title">' + title + '</span>' +
          (price ? '<span class="bs-pdp-sticky-bar__price">' + price + '</span>' : '') +
        '</span>' +
        '<span class="bs-pdp-sticky-bar__cta">' +
          '<button class="button bs-pdp-sticky-bar__btn" type="button" aria-label="Dodaj do koszyka"><svg class="bs-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 19h6"/><path d="M19 16v6"/><path d="M12.5 21h-4.5a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v3.5"/><path d="M9 7v-1a3 3 0 0 1 6 0v1"/></svg>Dodaj do koszyka</button>' +
        '</span>' +
      '</div>';
    document.body.appendChild(bar);

    bar.querySelector('.bs-pdp-sticky-bar__btn').addEventListener('click', function () {
      var addBtn = buyButtons.querySelector('[name="add"], .product-form__submit');
      if (addBtn) {
        addBtn.click();
      } else {
        buyButtons.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Pokaz pasek tylko gdy buy-box jest ponad widokiem (przewinieto w dol).
        var below = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !entry.isIntersecting && below);
      });
    }, { threshold: 0 });
    observer.observe(buyButtons);
  }

  function init() { buildBar(); }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', function () {
    var existing = document.querySelector('.bs-pdp-sticky-bar');
    if (existing) existing.remove();
    init();
  });
})();
